import axios from "axios";
import { ADD_VENDOR, GET_ALL_VENDORS, CHANGE_VENDOR_STATUS, GET_VENDOR_RELATE_DETAILS , GET_ACTIVE_VENDORS} from "../config/urlConfig";


// <-------------------------VENDOR------------------------------------>
// Function for handling add vendor api
export async function handleAddVendorApi(vendorData, token) {
  try {
    let formData = new FormData();
    for (let key in vendorData) {
      if (
        typeof vendorData[key] === "object" &&
        vendorData[key] !== null &&
        !(vendorData[key] instanceof File)
      ) {
        // Convert object to a JSON string before appending
        formData.append(key, JSON.stringify(vendorData[key]));
      } else {
        formData.append(key, vendorData[key]);
      }
    }
    
    let response = await axios.post(ADD_VENDOR, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all vendors
export async function getAllVendorsDetailsApi(token,  page, itemsPerPage) {
  try {
    const params = new URLSearchParams()

    params.append('page',page)
    params.append('limit', itemsPerPage)
    let response = await axios.get(`${GET_ALL_VENDORS}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for handling change sub vendor status  api
export async function handleChangeVendorStatusApi(vendorId, token) {
  try {

    let response = await axios.patch(`${CHANGE_VENDOR_STATUS}/${vendorId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}



// Function for fetch particular vendor & their distributor
export async function  fetchVendorDetailsWithDistributorsApi(token,vendorId) {
  try {
      let response = await axios.get(`${GET_VENDOR_RELATE_DETAILS}/${vendorId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


// Function for fetch all active Manufacture
export async function  getAllActiveManufacturersApi(token) {
  try {
    let response = await axios.get(GET_ACTIVE_VENDORS, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}